/**
 * Pure helpers for GraphCanvas native right-click hit-testing.
 * Kept free of React/Cytoscape instance so unit tests can lock the contract:
 * empty canvas → suppress only; node/edge hit → open in-app menu.
 */
export type CanvasHitKind = 'node' | 'edge' | 'empty';

export function classifyCanvasHit(near: { isNode?: () => boolean; isEdge?: () => boolean } | null | undefined): CanvasHitKind {
    if (!near) return 'empty';
    if (typeof near.isNode === 'function' && near.isNode()) return 'node';
    if (typeof near.isEdge === 'function' && near.isEdge()) return 'edge';
    return 'empty';
}

/** Whether a second open within `windowMs` should be ignored (cxttap vs contextmenu). */
export function shouldIgnoreDuplicateContextMenu(lastOpenAt: number, now: number, windowMs = 400): boolean {
    return now - lastOpenAt < windowMs;
}
